import React, { useState} from "react";
import "./Styles.css";
import {Button, FormGroup, FormControl}from '@mui/material';
import { EpCheckpoint } from "./EpCheckpoint";
import {SaveAlert} from "./SaveAlert";

export const Endpoints = ({apiConfig, endpts, onEditEndpoint, selectedEp, onSelectEp, onDeleteEndpoint, onCreateAssignedEndpoint}) => {

  const [alertOpen, setAlertOpen]=useState(false);

  const message = () => {
    console.log(selectedEp)
    if (selectedEp.length === 0) {
        return "You have not selected any endpoints.";
    } 
    if (selectedEp.length === 1) {
        return "You have selected the endpoint: " + selectedEp[0].Name;
    } else {
      var selectedEndpoints = []
      selectedEp.forEach(element => {
        selectedEndpoints.push(element.Name)
      });
        return "You have selected the endpoints: " + selectedEndpoints.join(", ");
    }
  }


  const handleYes =() => {
    setAlertOpen(false);
    onCreateAssignedEndpoint(selectedEp);
  }

  const [deleteAlert, setDeleteAlert] = useState(null);

const handleDeleteYes =(endpointId) => {
  setDeleteAlert(false);
  // deleteEndpoint(epName)
  // apiConfig.deleteEndpoint(endpointId)
  onDeleteEndpoint(endpointId)
}

  return (
    <div className="middle">
      <FormControl component="fieldset" className='EpFormControl'>
        <FormGroup className='FormGroup'>
          {endpts.map((endpoint) => (
            <div key={endpoint.Name} className="epCheckbox">
              <EpCheckpoint
                value={endpoint.Name}
                checked={selectedEp.includes(endpoint)} //sets the initial checkbox
                onChange={() => onSelectEp(endpoint)} //updates to the checked ep
                name={endpoint.Name}
                label={endpoint.Name}
                onClick={() => onEditEndpoint(endpoint)}
                onClickdel={() => setDeleteAlert(endpoint.Id)}
              />
            </div>
          ))}
          </FormGroup>
          <Button onClick={() => setAlertOpen(true)} variant="contained" className='SaveButton'>Save</Button> 
        
          {alertOpen && <SaveAlert onClose={() => setAlertOpen(false)} onYes={handleYes} heading={"Save endpoints?"} message={message} linkTo = {false}/>}
          {deleteAlert && <SaveAlert onClose={() => setDeleteAlert(null)} onYes={() => handleDeleteYes(deleteAlert)} heading={"Delete endpoint?"} message={null} />}
          
      </FormControl>
    </div>
  );
};

export default Endpoints;